import {
  MutationCache,
  QueryClient,
  type DefaultOptions,
  type QueryKey,
} from '@tanstack/react-query'

import type { AssistantEffect } from './assistant-effects.generated'

declare module '@tanstack/react-query' {
  interface Register {
    queryMeta: {
      assistantEffects?: readonly AssistantEffect[]
    }
    mutationMeta: {
      invalidates?: QueryKey[]
    }
  }
}

export function createQueryClient(defaultOptions?: DefaultOptions): QueryClient {
  const client: QueryClient = new QueryClient({
    mutationCache: new MutationCache({
      onSuccess: (_data, _variables, _context, mutation) => {
        for (const queryKey of mutation.meta?.invalidates ?? [])
          void client.invalidateQueries({ queryKey })
      },
    }),
    defaultOptions,
  })
  return client
}

// Single app-wide client. Entity reads are cheap and change rarely, so a short
// staleTime dedupes the burst of reads a navigation triggers without holding
// data stale for long. One retry — the Host is in-cluster, not the open net.
export const queryClient = createQueryClient({
  queries: {
    staleTime: 30_000,
    retry: 1,
  },
})
